import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IInvoiceLine extends IBaseEntity {
    id?: number;
    haulierOrder: any;
    haulierOrderId: number;
    rate: number;
    discount: number;
    total: number;
    nominalCodeId?: number;
    nominalCodeDetails?: any;
}

export class InvoiceLine extends BaseEntity implements IInvoiceLine {
    public id?: number;
    public haulierOrder: any;
    public haulierOrderId: number;
    public rate: number;
    public discount: number;
    public total: number;
    public nominalCodeId?: number;
    public nominalCodeDetails?: any;

    constructor(invoiceLine?: any) {
        super();
        if (invoiceLine) {
            this.id = invoiceLine.id;
            this.haulierOrder = invoiceLine.haulierOrder;
            this.haulierOrderId = invoiceLine.haulierOrder ? invoiceLine.haulierOrder.id : invoiceLine.haulierOrderId;
            this.rate = invoiceLine.rate;
            this.discount = invoiceLine.discount;
            this.total = invoiceLine.total;
            // Must be copied here: getRequest() rebuilds every line through this constructor, so a field
            // present on the form but missing here is silently dropped on save.
            this.nominalCodeId = invoiceLine.nominalCodeId;
            this.nominalCodeDetails = invoiceLine.nominalCodeDetails;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): InvoiceLine {
        return new InvoiceLine(this);
    }
}
